import { computed } from "vue";
import { usePreferredDark } from "@vueuse/core";
import { isClassicThemeActive } from "@/router/classicTheme";
import lightPng from "@/assets/images/pitchview_logo.png";
import lightSvg from "@/assets/images/logo_pitchview_large.svg";
import darkPng from "@/assets/images/pitchview_logo_dark_white.png";
import darkSvg from "@/assets/images/pitchview_logo_dark_white.svg";

// Theme ownership is synchronized before App mounts and on route changes.
export function usePitchviewLogo(format: "png" | "svg" = "png") {
  const prefersDark = usePreferredDark();
  return computed(() => {
    const dark = isClassicThemeActive.value && prefersDark.value;
    return format === "svg"
      ? dark
        ? darkSvg
        : lightSvg
      : dark
        ? darkPng
        : lightPng;
  });
}
